document.addEventListener("DOMContentLoaded", function() {
  function removeTargets(node) {
    if (!node) return;

    if (node.id === "chat-bubble" || node.classList?.contains("whatsapp-widget")) {
      node.remove();
      return;
    }

    if (node.classList?.contains("iubenda-tp-btn")) {
      node.remove();
      return;
    }

    node.querySelectorAll?.("#chat-bubble, .whatsapp-widget, .iubenda-tp-btn").forEach(el => el.remove());
  }

  document.querySelectorAll("#chat-bubble, .whatsapp-widget, .iubenda-tp-btn").forEach(el => el.remove());

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) removeTargets(node);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
